module.exports = __webpack_public_path__ + "static/media/signal.daf217a8.svg";